import {JourneyTrack} from '../journey-track';
import {TrackTypes} from '../model/track-types';
import {TrackInfo} from '../model/track-info';
import {TrackActionResult} from "../model/track-action-result";
import {ContaIonDataParse} from "../conta-ion/util/conta-ion-data-parse";
import {CacheService} from "../../../comunicator-native/cache/v2/cache.service";

export class BasicAddressTrack extends JourneyTrack {
  readonly originalTracks = [
      
    new TrackInfo('cep', ['address', 'cep']),
    new TrackInfo('address-name', ['address', 'name']),
    new TrackInfo('address-number', ['address', 'number']),
    new TrackInfo('address-adjunt', ['address', 'adjunt']),
    new TrackInfo('district', ['address', 'district']),
    new TrackInfo('address-state', ['address', 'state']),
    new TrackInfo('address-city', ['address', 'city']),
  ];

  track = [];

  constructor(private cacheNativeService: CacheService) {
    super();
    this.track = this.originalTracks;
  }

  
  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC;
  }

  async loadData(){
    // MobileMockData.executeMockCall(500);
    let data = await this.cacheNativeService.getItemCommunicator();
    data = ContaIonDataParse.parseFromMobileData(data);
    localStorage.setItem('cache-native', JSON.stringify(data));
    return Promise.resolve(data);
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    throw new Error('Method not implemented.');
  }
  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return true;
  }

  isBackHeader() {
    return false;
  }

}